import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const [token] = useState(() => params.get("token") || "");
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const [valid, setValid] = useState(false);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [existing, setExisting] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    // Bearer link stays in memory, out of subsequent referrers/history.
    window.history.replaceState(null, "", "/convite");
    api.post("/invites/validate", { token }).then(() => setValid(true)).catch(() => setError("Convite inválido ou indisponível."));
  }, [token]);
  const accept = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try {
      if (existing && !user) await login(email, password);
      await api.post("/invites/accept", { token, ...(!existing ? { password } : {}) });
      logout(); navigate("/login", { state: { message: "Convite aceito. Entre para acessar a empresa." } });
    } catch (err) { setError(formatError(err)); }
    finally { setBusy(false); }
  };
  return <div className="min-h-screen flex items-center justify-center p-6"><Card className="glass w-full max-w-md"><CardContent className="p-6 space-y-4">
    <h1 className="font-display text-2xl font-bold">Aceitar convite</h1>
    <p className="text-sm text-muted-foreground">Para uma conta nova, defina sua senha. Se já usa o PME, entre com o e-mail que recebeu o convite.</p>
    {error && <p role="alert" className="text-red-400">{error}</p>}
    {valid && <form onSubmit={accept} className="space-y-4">
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={existing} onChange={(e) => setExisting(e.target.checked)} />Já tenho uma conta</label>
      {existing && user ? <p className="text-sm">Conta autenticada: {user.email}</p> : <>
        {existing && <div><Label>E-mail</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" /></div>}
        <div><Label>{existing ? "Senha atual" : "Nova senha"}</Label><Input type="password" required minLength={8} maxLength={72} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete={existing ? "current-password" : "new-password"} /></div>
      </>}
      <Button type="submit" disabled={busy} className="w-full gradient-brand">{busy ? "Aguarde..." : "Aceitar convite"}</Button>
    </form>}
    <Link to="/login" className="text-sm underline">Voltar para o login</Link>
  </CardContent></Card></div>;
}
